import React, { useState } from 'react';
//import { useHistory } from "react-router-dom";
import Menu from './components/Menu';
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Input, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap';
import axios from 'axios';
import InputMask from "react-input-mask";
import helpers from "./helpers/Utilities";
import sqlstring from 'sqlstring';
import constants from './helpers/Constants';
import './App.css';

function Cadastro2() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    const [cpf, setCPF] = useState(JSON.parse(localStorage.getItem('usuario_logado')).cpf);
    const [nome, setNome] = useState(JSON.parse(localStorage.getItem('usuario_logado')).nome);
    const [email, setEmail] = useState(JSON.parse(localStorage.getItem('usuario_logado')).email);
    const [nascimento, setNascimento] = useState(helpers.formatDateBR(JSON.parse(localStorage.getItem('usuario_logado')).nascimento));
    const [nacionalidade, setNacionalidade] = useState(JSON.parse(localStorage.getItem('usuario_logado')).nacionalidade);
    const [rg, setRg] = useState(JSON.parse(localStorage.getItem('usuario_logado')).rg);
    const [cep, setCep] = useState(JSON.parse(localStorage.getItem('usuario_logado')).cep);
    const [logradouro, setLogradouro] = useState(JSON.parse(localStorage.getItem('usuario_logado')).logradouro);
    const [numero, setNumero] = useState(JSON.parse(localStorage.getItem('usuario_logado')).numero);
    const [complemento, setComplemento] = useState(JSON.parse(localStorage.getItem('usuario_logado')).complemento);
    const [bairro, setBairro] = useState(JSON.parse(localStorage.getItem('usuario_logado')).bairro);
    const [cidade, setCidade] = useState(JSON.parse(localStorage.getItem('usuario_logado')).cidade);
    const [estado, setEstado] = useState(JSON.parse(localStorage.getItem('usuario_logado')).estado);
    const [celular, setCelular] = useState(JSON.parse(localStorage.getItem('usuario_logado')).celular);
    const [tipoSanguineo, setTipoSanguineo] = useState(JSON.parse(localStorage.getItem('usuario_logado')).tipo_sanguineo);
    const [tamanhoCamiseta, setTamanhoCamiseta] = useState(JSON.parse(localStorage.getItem('usuario_logado')).tamanho_camiseta);
    const [instrutor, setInstrutor] = useState(JSON.parse(localStorage.getItem('usuario_logado')).instrutor);
    const [numeroFaixa, setNumeroFaixa] = useState(JSON.parse(localStorage.getItem('usuario_logado')).numero_faixa);
    const [profissao, setProfissao] = useState(JSON.parse(localStorage.getItem('usuario_logado')).profissao);
    const [empresa, setEmpresa] = useState(JSON.parse(localStorage.getItem('usuario_logado')).empresa);
    const [mae, setMae] = useState(JSON.parse(localStorage.getItem('usuario_logado')).mae);
    const [pai, setPai] = useState(JSON.parse(localStorage.getItem('usuario_logado')).pai);
    const [nacionalidadeMae, setNacionalidadeMae] = useState(JSON.parse(localStorage.getItem('usuario_logado')).nacionalidade_mae);
    const [nacionalidadePai, setNacionalidadePai] = useState(JSON.parse(localStorage.getItem('usuario_logado')).nacionalidade_pai);
    const [faixa, setFaixa] = useState(JSON.parse(localStorage.getItem('usuario_logado')).faixa);

    const [showMsg, setShowMsg] = useState(false);
    const [showMsgOK, setShowMsgOK] = useState(false);
    const [msg, setMsg] = useState('');
    const toggleMsg = () => setShowMsg(!showMsg);
    const toggleMsgOK = () => setShowMsgOK(!showMsgOK);

    const [validated, setValidated] = useState(false);

    //const history = useHistory();

    const handleCEP = (e) => {

        const sCEP = cep.replace(/_/g, '').replace(/-/g, '');

        if (sCEP.length === 8) {
            axios.get(`https://viacep.com.br/ws/${sCEP}/json/`)
                .then(function (response) {
                    console.log(response);
                    if (response.data.length === 0) {
                        setMsg('CEP Inválido. Endereço não encontrado.');
                        toggleMsg();
                    }
                    else {
                        const data = response.data;
                        setLogradouro(data.logradouro);
                        setBairro(data.bairro);
                        setCidade(data.localidade);
                        setEstado(data.uf);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    };

    const handleContinuar = () => {

        if (helpers.isEmpty(nome) || !helpers.isEmail(email) ||
            celular.trim().length < 15 || nascimento.trim().length < 10 || !helpers.isDate(nascimento) ||
            cep.trim().length < 8) {
            setMsg('Por favor preencha corretamente os campos destacados.');
            toggleMsg();
            setValidated(true);
        }
        else {
            setValidated(false);
            let cmd = `UPDATE associado SET `;
            cmd += `  nome=${sqlstring.escape(nome)}`;
            cmd += `, email=${sqlstring.escape(email)}`;
            cmd += `, nascimento='${helpers.formatDateDB(nascimento)}'`;
            cmd += `, nacionalidade=${sqlstring.escape(nacionalidade)}`;
            cmd += `, rg=${sqlstring.escape(rg)}`;
            cmd += `, cep=${sqlstring.escape(cep)}`;
            cmd += `, logradouro=${sqlstring.escape(logradouro)}`;
            cmd += `, numero=${sqlstring.escape(numero)}`;
            cmd += `, complemento=${sqlstring.escape(complemento)}`;
            cmd += `, bairro=${sqlstring.escape(bairro)}`;
            cmd += `, cidade=${sqlstring.escape(cidade)}`;
            cmd += `, estado=${sqlstring.escape(estado)}`;
            cmd += `, celular=${sqlstring.escape(celular)}`;
            cmd += `, tipo_sanguineo=${sqlstring.escape(tipoSanguineo)}`;
            cmd += `, tamanho_camiseta=${sqlstring.escape(tamanhoCamiseta)}`;
            cmd += `, instrutor=${sqlstring.escape(instrutor)}`;
            cmd += `, numero_faixa=${sqlstring.escape(numeroFaixa)}`;
            cmd += `, profissao=${sqlstring.escape(profissao)}`;
            cmd += `, empresa=${sqlstring.escape(empresa)}`;
            cmd += `, mae=${sqlstring.escape(mae)}`;
            cmd += `, pai=${sqlstring.escape(pai)}`;
            cmd += `, nacionalidade_mae=${sqlstring.escape(nacionalidadeMae)}`;
            cmd += `, nacionalidade_pai=${sqlstring.escape(nacionalidadePai)}`;
            cmd += `, faixa=${sqlstring.escape(faixa)}`;
            cmd += ` WHERE cpf = '${cpf}'`;

            axios({
                method: 'post',
                url: constants.APIURLExec,
                headers: {
                    'APITOKEN': constants.APIToken
                },
                data: {
                    cmd: cmd
                }
            })
            .then(function (response) {
                console.log(response);
                if (response.data.ok) {
                    axios({
                        method: 'post',
                        url: constants.APIURLGet,
                        headers: {
                          'APITOKEN': constants.APIToken
                        },
                        data: {
                          query: `select * from associado where cpf = '${cpf}'`
                        }
                    })
                    .then(function (response) {
                        let associado = JSON.stringify(response.data[0]);
                        localStorage.setItem("usuario_logado", associado);
                    });
                    setShowMsgOK(true);
                }
            })
            .catch(function (error) {
                console.log(error);
            });

        }

    };

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Dados Pessoais</NavbarBrand>
                </Navbar>
                <Container className="mb-5">
                    <Modal isOpen={showMsg}>
                        <ModalBody>
                            {msg}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={toggleMsg}>OK</Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={showMsgOK}>
                        <ModalBody>
                            Dados alterados com sucesso.
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={toggleMsgOK}>OK</Button>
                        </ModalFooter>
                    </Modal>
                    <Row>
                        <Col className="mt-3">
                            <InputMask readOnly mask="999.999.999-99" placeholder="CPF" value={cpf} onChange={(e) => setCPF(e.target.value)} className="form-control"></InputMask>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className={`form-control ${(validated && helpers.isEmpty(nome) ? 'is-invalid' : '')}`} placeholder="Nome Completo" value={nome} onChange={(e) => setNome(e.target.value)}></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className={`form-control ${(validated && !helpers.isEmail(email) ? 'is-invalid' : '')}`} placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <InputMask className={`form-control ${(validated && (helpers.isEmpty(celular) || celular.trim().length < 15) ? 'is-invalid' : '')}`} mask="(99) 99999-9999" placeholder="Celular" value={celular} onChange={(e) => setCelular(e.target.value)}></InputMask>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <InputMask className={`form-control ${(validated && (!helpers.isDate(nascimento) || nascimento.trim().length < 10) ? 'is-invalid' : '')}`} mask="99/99/9999" placeholder="Data de Nascimento" value={nascimento} onChange={(e) => setNascimento(e.target.value)}></InputMask>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="RG" value={rg} onChange={(e) => setRg(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Nacionalidade" value={nacionalidade} onChange={(e) => setNacionalidade(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <InputMask className={`form-control ${(validated && (helpers.isEmpty(cep) || cep.trim().length < 8) ? 'is-invalid' : '')}`} mask="99999999" placeholder="CEP" value={cep} onBlur={handleCEP} onChange={(e) => setCep(e.target.value)}></InputMask>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input readOnly className="form-control" placeholder="Endereço" value={logradouro} onChange={(e) => setLogradouro(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Número" value={numero} onChange={(e) => setNumero(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Complemento" value={complemento} onChange={(e) => setComplemento(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input readOnly className="form-control" placeholder="Bairro" value={bairro} onChange={(e) => setLogradouro(e.target.bairro)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input readOnly className="form-control" placeholder="Cidade" value={cidade} onChange={(e) => setLogradouro(e.target.cidade)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input readOnly className="form-control" placeholder="Estado" value={estado} onChange={(e) => setLogradouro(e.target.estado)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input type="select" value={tipoSanguineo} onChange={(e) => setTipoSanguineo(e.target.value)}>
                                <option value=''>Tipo Sanguíneo</option>
                                <option value='A+'>A+</option>
                                <option value='A-'>A-</option>
                                <option value='B+'>B+</option>
                                <option value='B-'>B-</option>
                                <option value='AB+'>AB+</option>
                                <option value='AB-'>AB-</option>
                                <option value='O+'>O+</option>
                                <option value='O-'>O-</option>
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input type="select" value={tamanhoCamiseta} onChange={(e) => setTamanhoCamiseta(e.target.value)}>
                                <option value=''>Tamanho da Camiseta</option>
                                <option value='10'>10</option>
                                <option value='12'>12</option>
                                <option value='14'>14</option>
                                <option value='PP'>PP</option>
                                <option value='P'>P</option>
                                <option value='M'>M</option>
                                <option value='G'>G</option>
                                <option value='GG'>GG</option>
                                <option value='XGG'>XGG</option>
                                <option value='XXGG'>XXGG</option>
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input type="select" value={numeroFaixa} onChange={(e) => setNumeroFaixa(e.target.value)}>
                                <option value=''>Tamanho da Calça</option>
                                <option value='10'>10</option>
                                <option value='12'>12</option>
                                <option value='14'>14</option>
                                <option value='PP'>PP</option>
                                <option value='P'>P</option>
                                <option value='M'>M</option>
                                <option value='G'>G</option>
                                <option value='GG'>GG</option>
                                <option value='XGG'>XGG</option>
                                <option value='XXGG'>XXGG</option>
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Instrutor" value={instrutor} onChange={(e) => setInstrutor(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input type="select" value={faixa} onChange={(e) => setFaixa(e.target.value)}>
                                <option value=''>Faixa</option>
                                <option value='Branca'>Branca</option>
                                <option value='Amarela'>Amarela</option>
                                <option value='Laranja'>Laranja</option>
                                <option value='Verde'>Verde</option>
                                <option value='Azul'>Azul</option>
                                <option value='Marrom'>Marrom</option>
                                <option value='Preta'>Preta</option>
                                <option value='Preta 2º Dan'>Preta 2º Dan</option>
                                <option value='Preta 3º Dan'>Preta 3º Dan</option>
                                <option value='Preta 4º Dan'>Preta 4º Dan</option>
                                <option value='Preta 5º Dan'>Preta 5º Dan</option>
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Profissão" value={profissao} onChange={(e) => setProfissao(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Empresa / Instituição de Ensino" value={empresa} onChange={(e) => setEmpresa(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Nome da Mãe" value={mae} onChange={(e) => setMae(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Nacionalidade da Mãe" value={nacionalidadeMae} onChange={(e) => setNacionalidadeMae(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Nome do Pai" value={pai} onChange={(e) => setPai(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className="form-control" placeholder="Nacionalidade do Pai" value={nacionalidadePai} onChange={(e) => setNacionalidadePai(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3 mb-5">
                            <Button onClick={handleContinuar} className="btn btn-block btn-lg btn-primary btn-azul">SALVAR ALTERAÇÕES</Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Cadastro2;
